export default {
  path: '/factory-capacity',
  component: () => import('@/views/factoryCapacity/index.vue'),
  children: [
    {
      path: '',
      name: 'FactoryCapacity',
      component: () => import('@/views/factoryCapacity/pages/FactoryCapacity.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'merchandising_planner',
          'merchandiser',
          'developer'
        ]
      }
    }
  ]
}
